// opervex-frontend/src/Opervex/Tax/Inbound/index.js

import _NFe from "./NFe";

class System {
  #_api;

  constructor(api) {
    this.#_api = api;

    this.NFe = new _NFe(this.#_api);
  }
}

export default System;
